import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import StudentSidebar from './StudentSidebar';
import StudentHeader  from './StudentHeader';

const style = `
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html, body, #root { height:100%; width:100%; }

  .sl-root    { display:flex; height:100vh; width:100vw; overflow:hidden; background:#f0f2f7; position:relative; }
  .sl-sidebar {
    flex-shrink:0; width:240px; height:100vh;
    overflow-y:auto; overflow-x:hidden; transition:transform .25s ease;
    scrollbar-width:thin;
    scrollbar-color:#2a2f4e #0f1123;
  }
  .sl-sidebar::-webkit-scrollbar { width:4px; }
  .sl-sidebar::-webkit-scrollbar-thumb { background:#2a2f4e; border-radius:99px; }
  .sl-sidebar::-webkit-scrollbar-track { background:#0f1123; }
  .sl-body    { flex:1; display:flex; flex-direction:column; height:100vh; overflow:hidden; min-width:0; }
  .sl-header  { flex-shrink:0; }
  .sl-main    { flex:1; overflow-y:auto; overflow-x:hidden; padding:24px; scrollbar-width:thin; scrollbar-color:#dde1ef transparent; }
  .sl-main::-webkit-scrollbar { width:5px; }
  .sl-main::-webkit-scrollbar-thumb { background:#dde1ef; border-radius:99px; }

  .sl-sidebar-backdrop { display:none; position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:199; }

  @media (max-width:768px) {
    .sl-main { padding:16px; }
    .sl-sidebar {
      position:fixed; left:0; top:0; bottom:0; z-index:200;
      transform:translateX(-100%);
    }
    .sl-sidebar.open {
      transform:translateX(0);
      box-shadow:4px 0 24px rgba(0,0,0,.3);
    }
    .sl-sidebar-backdrop.open { display:block; }
  }
`;

const StudentLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      <style>{style}</style>
      <div className="sl-root">
        <div className={`sl-sidebar-backdrop ${sidebarOpen?'open':''}`} onClick={()=>setSidebarOpen(false)} />
        <div className={`sl-sidebar ${sidebarOpen?'open':''}`}>
          <StudentSidebar onClose={()=>setSidebarOpen(false)} />
        </div>
        <div className="sl-body">
          <div className="sl-header">
            <StudentHeader onMenuClick={()=>setSidebarOpen(o=>!o)} />
          </div>
          <main className="sl-main"><Outlet /></main>
        </div>
      </div>
    </>
  );
};

export default StudentLayout;